<template>
  <div class="horizon-container">
    <div id="moveLeft" class="h-100 flex-column bg-ff" style="width: 250px">
      <div class="left-top">
        <div class="flex-1 font-16-30313a">报表分类</div>
      </div>
      <div class="flex-1 h-0" v-if="menuList && menuList.length">
        <cate-menu :not-operate="true" :isReport="true" :menu-data="menuList" @on-choose="onChooseMenu" :choose-id="chooseMenuId"></cate-menu>
      </div>
    </div>
    <move-horizon></move-horizon>
    <div class="flex-1 h-100 flex-column ptb-10 pr-20 pl-10 w-0">
      <div class="flex content-top mb-10">
        <div class="flex-1 bg-ff h-100 flex align-center pl-5 mr-10">
          <div class="tab-item active">
            <span class="bg-4-f5971d"></span>
            {{currentClassify.name}}
          </div>
        </div>
        <div class="my-picker align-center">
          <el-date-picker
            v-model="dataInfo"
            type="daterange"
            align="right"
            unlink-panels
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            @change="onDateChange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions">
          </el-date-picker>
        </div>
        <div class="flex ml-10">
          <div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10 search">
            <img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">
            <el-input type="text" placeholder="输入关键字" v-model="keyword" clearable @keyup.enter.native="getReportData"></el-input>
          </div>
          <button class="btn-30-bg-82b925" @click="getReportData">搜索</button>
        </div>
      </div>
      <div class="flex align-center mb-10 flex-wrap">
        <div class="btn-30-bg-82b925-big mr-10" @click="webapp({})">打印预览</div>
        <div class="btn-30-bg-f5971d mr-10" @click="webapp({'type':'print'})">打印</div>
        <div class="btn-30-border-30313a mr-10" @click="webapp({'type':'print', 'showOptionDlg': 'false'})">直接打印</div>
        <div class="btn-30-border-f5971d-s mr-10" @click="webapp({'type':'pdf'})">导出PDF</div>
        <div class="btn-30-bg-82b925-big mr-10" @click="webapp({'type':'xls'})" v-if="permission.indexOf('exportExcel') > -1">导出Excel</div>
        <div class="btn-30-bg-f5971d mr-10" @click="webapp({'type':'rtf'})">导出RTF</div>
        <div class="btn-30-border-f5971d-s mr-10" @click="webapp({'type':'csv'})">导出CSV</div>
        <div class="btn-30-border-30313a mr-10" @click="webapp({'type':'txt'})">导出文本</div>
        <div class="btn-30-bg-f5971d mr-10" @click="webapp({'type':'img'})">导出图像</div>
        <div class="btn-30-bg-82b925-big mr-10" @click="webapp({'type':'grd'})">生成报表文档</div>
      </div>
      <div class="flex-1 h-0">
        <el-scrollbar class="h-100 w-100 hide-x">
          <div class="h-100">
            <div class="p-20">
              <div id="report_holder">
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import CateMenu from '../../components/CateMenu'
import ErpTable from '../../components/ErpTable'
import MoveHorizon from '../../components/MoveHorizon'
import Grh from '@/utils/grhtml5-6.6-min.js'
import reportApi from '@/utils/grwebapp.js'
export default {
  name: 'index',
  components: {CateMenu, ErpTable, MoveHorizon},
  data () {
    return {
      reportViewer: null,
      data: '',
      sqlStatement: '',
      chooseMenuId: 1,
      menuList: [],
      menuList1: [],
      menuList2: [],
      currentClassify: {},
      dataInfo: '',
      starttime: '',
      endtime: '',
      keyword: '',
      isShow: false,
      permission: null,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  created () {
    this.reportViewer = Grh.rubylong.grhtml5.insertReportViewer('report_holder')
    this.reportViewer.dataPrepared = false
    this.getReportClassify()
    this.getPermission()
  },
  mounted () {},
  methods: {
    getPermission () {
      this.axios.post(`${this.$store.state.API_URL_9010}/permission/permissionStr`, {
        parent: 'decisionCenter',
        parentGroup: 'decisionCenter'
      }).then(res => {
        if (res.data.success) {
          this.permission = res.data.data
          console.log(this.permission)
        }
      })
    },
    webapp (args) {
      args.scripts = [{
        event: 'Initialize'
      }]
      args.report = this.reportViewer.reportText
      args.data = this.reportViewer.dataText
      reportApi.webapp_ws_ajax_run(args)
    },
    getReportData () {
      let that = this
      let params = {
        querySql: that.sqlStatement,
        keyword: that.keyword,
        endtime: that.dataInfo[1],
        starttime: that.dataInfo[0]
      }
      if (that.sqlStatement != null && that.sqlStatement !== '') {
        that.axios.post(`${this.$store.state.API_URL_9010}/report/getReportData`, that.qs.stringify(params)).then(res => {
          that.data = res.data
          that.reportViewer.loadData(res.data)
          that.reportViewer.start()
          reportApi.webapp_urlprotocol_startup()
        })
      }
    },
    onDateChange (e) {
      this.starttime = e[0]
      this.endtime = e[1]
      this.getReportData()
    },
    getReport () {
      let that = this
      if (!this.currentClassify.grf) {
        this.$message({
          message: '该报表还没有模板！',
          type: 'warning',
          offset: 400
        })
        return
      }
      this.axios.post(`${this.$store.state.API_URL_9010}/report/getGrf`, this.qs.stringify({grf: this.currentClassify.grf})).then(res => {
        if (res.data.success) {
          this.isShow = true
          let jsonObj = that.evil('(' + res.data.data + ')')
          let reportSource = JSON.stringify(jsonObj)
          that.reportViewer.loadReport(reportSource)
          that.sqlStatement = jsonObj.DetailGrid.Recordset.QuerySQL
          that.getReportData()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getReportStr (menu, index) {
      this.axios.post(`${this.$store.state.API_URL_9010}/reportPermission/listStr`, {companyId: this.$store.state.companyId, classifyId: menu.id, roleId: this.$store.state.user.roleId}).then(res => {
        if (res.data.success) {
          for (let j = 0; j < menu.children.length; j++) {
            let arr = res.data.data.split(',')
            this.menuList[index].children = []
            for (let m = 0; m < arr.length; m++) {
              if (arr[m] === menu.children[j].id) {
                this.menuList[index].children.push(menu.children[j])
              }
            }
          }
        }
      })
    },
    getReportClassify () {
      this.axios.post(`${this.$store.state.API_URL_9010}/reportClassify/findAll`, {type: 1, companyId: this.$store.state.companyId}).then(res => {
        if (res.data.success) {
          let list = res.data.data
          for (let i = 0; i < list.length; i++) {
            this.axios.post(`${this.$store.state.API_URL_9010}/reportPermission/listStr`, {companyId: this.$store.state.companyId, classifyId: list[i].id, roleId: this.$store.state.user.roleId}).then(res => {
              if (res.data.success) {
                let arr = res.data.data.split(',')
                let child = []
                for (let j = 0; j < list[i].children.length; j++) {
                  for (let m = 0; m < arr.length; m++) {
                    if (arr[m] === list[i].children[j].id) {
                      child.push(list[i].children[j])
                    }
                  }
                }
                list[i].children = child
              }
            })
          }
          this.menuList = list
          this.getDefaultId(this.menuList)
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onChooseMenu (menu, index) {
      if (!menu.children || menu.length === 0) {
        if (menu.id !== this.chooseMenuId) {
          this.isShow = false
          this.chooseMenuId = menu.id
          this.currentClassify = menu
          if (this.reportViewer) {
            this.reportViewer.stop(false, false)
          }
          // this.reportViewer = null
          this.getReport()
          // this.getReportStr(menu, index)
        }
      }
    },
    getDefaultId (list) {
      if (list && list.length) {
        let data = list[0]
        if (data.children && data.children.length) {
          this.getDefaultId(data.children)
        } else {
          this.chooseMenuId = data.id
          this.currentClassify = data
          this.getReport()
          // this.getReportStr(data, 0)
        }
      }
    },
    evil (fn) {
      var Fn = Function // 一个变量指向Function，防止有些前端编译工具报错
      return new Fn('return ' + fn)()
    }
  },
  watch: {
    keyword (val) {
      if (val === '') {
        this.getReportData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .my-picker /deep/ .el-range__close-icon{
    line-height: 25px;
  }
  .my-picker /deep/ .el-range-separator{
    width: 44px;
  }
  table{
    width: 100%;
  }
  .search {
    overflow: hidden;
  }
  .search /deep/.el-input__inner{
    padding-left: 0;
    border: none;
    outline: none;
  }
  .left-top {
    display: flex;
    align-items: center;
    padding: 0 10px 0 20px;
    border-bottom: 1px solid #e2e2e2;
    height: 40px;
    text-align: left;
    cursor: pointer;
  }
  .content-top {
    height: 30px;
    .tab-item {
      font-size: 16px;
      color: #272727;
      display: flex;
      align-items: center;
      margin-right: 15px;
      cursor: pointer;
      span {
        height: 16px;
      }
      &.active {
        color: #f5971d;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/decisionCenter/index.vue